import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { axiosInstance } from '../../axios/interceptor'

export const getAllTemplate = createAsyncThunk('template/all', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/template/get-all-templates`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const addTemplate = createAsyncThunk('template/add', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/template/create-templates`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getTemplateByID = createAsyncThunk('template/get', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/template/get-template/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const deleteTemplate = createAsyncThunk('template/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.delete(`/template/delete-template/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const updateTemplate = createAsyncThunk('template/update', async (data, { rejectWithValue }) => {
  const { template_id, ...rest } = data
  try {
    const response = await axiosInstance.put(`/template/update-template/${template_id}`, rest)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllCleanersInfo = createAsyncThunk('template/cleaners/get', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/cleaner/get-all-cleaners-basic-details`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllClientsInfo = createAsyncThunk('template/clients/get', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/client/get-all-client-basic-details`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const sendEmailTemplates=createAsyncThunk('template/send-email',async(data,{rejectWithValue})=>{
  try {
    const response = await axiosInstance.post(`/template/send-email-templates`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const sendNotificationTemplates=createAsyncThunk('template/send-notification',async(data,{rejectWithValue})=>{
  try {
    const response = await axiosInstance.post(`/template/send-notification-templates`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  templatesData: [],
  cleanerData: [],
  clientsData:[],
  error: null,
  templateInfo: null
}

const templateSlice = createSlice({
  name: 'templates',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllTemplate.pending, (state) => {
        state.isLoading = true
        state.templatesData = []
      })
      .addCase(getAllTemplate.fulfilled, (state, action) => {
        state.isLoading = false
        state.templatesData = action.payload?.data?.data
      })
      .addCase(getAllTemplate.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
        state.templatesData = []
      })
      .addCase(addTemplate.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addTemplate.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(addTemplate.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getTemplateByID.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getTemplateByID.fulfilled, (state, action) => {
        state.isLoading = false
        state.templateInfo = action.payload?.data?.data
      })
      .addCase(getTemplateByID.rejected, (state) => {
        state.isLoading = false
      })
      .addCase(deleteTemplate.pending, (state) => {
        state.isLoading = true
      })
      .addCase(deleteTemplate.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(deleteTemplate.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(updateTemplate.pending, (state) => {
        state.isLoading = true
      })
      .addCase(updateTemplate.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(updateTemplate.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAllCleanersInfo.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllCleanersInfo.fulfilled, (state, action) => {
        state.isLoading = false,
        state.cleanerData = action.payload?.data?.data
      })
      .addCase(getAllCleanersInfo.rejected, (state, action) => {
        state.isLoading = false,
        state.error = action.error.message
      })
      .addCase(getAllClientsInfo.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllClientsInfo.fulfilled, (state, action) => {
        state.isLoading = false,
        state.clientsData = action.payload?.data?.data
      })
      .addCase(getAllClientsInfo.rejected, (state, action) => {
        state.isLoading = false,
        state.error = action.error.message
      })
      .addCase(sendEmailTemplates.pending, (state) => {
        state.isLoading = true
      })
      .addCase(sendEmailTemplates.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(sendEmailTemplates.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(sendNotificationTemplates.pending, (state) => {
        state.isLoading = true
      })
      .addCase(sendNotificationTemplates.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(sendNotificationTemplates.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export default templateSlice.reducer
